import { dialogSearchFieldSx } from '../../../constants/dialogSx'

export const RBAC_USER_SELECTION_SCROLL_LOAD_THRESHOLD_PX = 80

export const rbacUserSelectionSearchFieldSx = dialogSearchFieldSx
